import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';

import { CompanyPlanTypes } from '@site-mate/sitemate-global-shared';

import { ActivityService } from 'app/home/activity/activity.service';
import { HomePagePeopleBaseComponent } from 'app/home/home-people-base.component';
import { SegmentService } from 'app/segment/segment.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { TeamService } from 'app/shared/service/team.service';
import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-project-home-activity',
  templateUrl: 'project-home-activity.component.html',
  styleUrls: ['home-page.component.scss'],
})
export class ProjectHomeActivityComponent extends HomePagePeopleBaseComponent implements OnInit, OnDestroy {
  projectId: string;
  title: string;
  isTrialUser: boolean;
  state: boolean;
  activityLevel = 'project';

  constructor(
    private readonly teamService: TeamService,
    protected readonly errorHandler: ErrorHandler,
    public readonly userService: UserService,
    protected readonly activityService: ActivityService,

    protected readonly segmentService: SegmentService,
  ) {
    super(errorHandler, segmentService, activityService);
  }

  ngOnInit(): void {
    this.teamService.currentTeam
      .pipe(
        takeUntil(this.unsub),
        filter((project) => project.isProject && project.id),
      )
      .subscribe((project) => {
        this.projectId = project.id;
        this.title = project.name;
        this.state = project.state;
        this.isTrialUser = project.companyMetadata?.billing?.planType === CompanyPlanTypes.FreeTrial;
        this.reloadActivities();
      });
  }

  loadActivitiesCore() {
    return this.activityService.getProjectUserActivities(
      this.projectId,
      this.activityLimit,
      this.activityOffset,
    );
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();
  }
}
